// extracted by mini-css-extract-plugin
module.exports = {"header":"faqs_header__xjG4M","block":"faqs_block__gH4n2","arrow":"faqs_arrow__mPZVp","btnGroup":"faqs_btnGroup___5tIs","list":"faqs_list__XHQJc"};